export default {"src":"/_next/static/media/precision_demographic_targeting.4182630c.svg","height":41,"width":41,"blurWidth":0,"blurHeight":0};